/*
 * Quick search (duplicate theme 175774957591)
 * Shopify's native Predictive Search API returns 417 "Unsupported buyer locale" for Hebrew,
 * so this drives the header search dropdown off the REGULAR Search API instead.
 * On input it debounce-fetches the `quick-search-results` section and injects the grid
 * into the `[data-quick-search-results]` container inside each search popdown.
 */
(function () {
  var SECTION = 'quick-search-results';
  var MIN_CHARS = 2;
  var DEBOUNCE = 250;

  function initForm(form) {
    if (form.__quickSearchInit) return;
    form.__quickSearchInit = true;

    var input = form.querySelector('input[name="q"]');
    var container = form.querySelector('[data-quick-search-results]');
    if (!input || !container) return;

    var timer = null;
    var controller = null;

    function clear() {
      container.innerHTML = '';
      container.setAttribute('hidden', '');
      container.removeAttribute('data-loading');
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      if (timer) clearTimeout(timer);
      if (controller) { controller.abort(); controller = null; }

      if (term.length < MIN_CHARS) { clear(); return; }

      container.removeAttribute('hidden');
      container.setAttribute('data-loading', '');
      timer = setTimeout(function () { run(term); }, DEBOUNCE);
    });

    // Reset when the popdown is closed
    var popdown = form.closest('search-popdown');
    if (popdown) {
      popdown.addEventListener('click', function (e) {
        if (e.target.closest('[data-popdown-close]')) clear();
      });
    }

    function run(term) {
      controller = new AbortController();
      var url = '/search?q=' + encodeURIComponent(term + '*') +
        '&type=product&options%5Bprefix%5D=last&section_id=' + SECTION;

      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('[data-quick-search-inner]');
          container.innerHTML = inner ? inner.outerHTML : '';
          container.removeAttribute('data-loading');
          container.removeAttribute('hidden');

          // Point "view all" at the clean term (no wildcard)
          var viewAll = container.querySelector('[data-quick-search-view-all]');
          if (viewAll) {
            viewAll.setAttribute('href', '/search?q=' + encodeURIComponent(term) + '&type=product');
          }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          container.removeAttribute('data-loading');
        });
    }
  }

  function initAll() {
    var forms = document.querySelectorAll('[data-search-form]');
    for (var i = 0; i < forms.length; i++) initForm(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Search popdowns can be added/hydrated late; re-scan on interaction.
  document.addEventListener('click', function (e) {
    if (e.target.closest('search-popdown, [data-popdown-toggle], .search_icon')) initAll();
  });
})();
